import {
    GET_CONFIG_FORM16, 
    GET_DATOS_CARTA_CIA_TERCERO,
    GET_COMBO_VEHICULOS,
    GET_COMBO_MARCAS,
    GET_COMBO_COMPANIAS,
    GET_MONTOS,
    POST_ACTUALIZAR_CIA,
    SET_LOADING_CARTA,
    GET_SOLICITUD_DESCUENTO,
    GET_PARAMETROS
} from '../types';

export default function modalCartaCiaTerceroReducer(state = {}, action) {
    switch (action.type) {
        case GET_CONFIG_FORM16:
            return { ...state, cfg_form16:action.payload }
        case GET_DATOS_CARTA_CIA_TERCERO:
            return { ...state, datosCIATErcero:action.payload }
        case GET_PARAMETROS:
            return { ...state, parametros:action.payload }
        case GET_COMBO_VEHICULOS:
            return { ...state, comboTipoVehiculos:action.payload }
        case GET_COMBO_MARCAS:
            return { ...state, comboMarcas:action.payload }
        case GET_COMBO_COMPANIAS:
            return { ...state, comboCompanias:action.payload }
        case GET_MONTOS:
            return { ...state, montosInformados:action.payload }
        case POST_ACTUALIZAR_CIA:
            return { ...state, respuestaModalCIA:action.payload }
            case GET_SOLICITUD_DESCUENTO:
                return { ...state, solicitudDescuento:action.payload }
            case SET_LOADING_CARTA:
                return { ...state, loadingCarta:action.payload }
       
       
        default:
            return state
    }
}